import React, { useState, useEffect } from 'react';
import './TerritoryButton.css';
import '../src/styles/font.css';

import territoryImageData from './territoryImageData';
import targetIndicator from './Assets/Images/GameBoard/target.png';

import BrazilSVG from './Assets/Images/GameBoard/WorldMap/Brazil/Brazil.png';
import PeruSVG from './Assets/Images/GameBoard/WorldMap/Peru/Peru.png';
import ArgentinaSVG from './Assets/Images/GameBoard/WorldMap/Argentina/Argentina.png';

import territoryOccupiedAnimation  from './Assets/Images/GameBoard/territoryOccupiedAnimation.png';
import troopAddedAnimation from './Assets/Images/GameBoard/troopsTooltip.png'

// Boom Animation Sprites

import Boom1 from './Assets/Images/GameBoard/BoomAnimation/SpriteAnimation/Boom1.png'; //'./Assets/Images/GameBoard/BoomAnimation/SpriteAnimation/Boom1.png';
import Boom2 from './Assets/Images/GameBoard/BoomAnimation/SpriteAnimation/Boom2.png';
import Boom3 from './Assets/Images/GameBoard/BoomAnimation/SpriteAnimation/Boom3.png';
import Boom4 from './Assets/Images/GameBoard/BoomAnimation/SpriteAnimation/Boom4.png';
import Boom5 from './Assets/Images/GameBoard/BoomAnimation/SpriteAnimation/Boom5.png';
import Boom6 from './Assets/Images/GameBoard/BoomAnimation/SpriteAnimation/Boom6.png';
import Boom7 from './Assets/Images/GameBoard/BoomAnimation/SpriteAnimation/Boom7.png';
import Boom8 from './Assets/Images/GameBoard/BoomAnimation/SpriteAnimation/Boom8.png';
import Boom9 from './Assets/Images/GameBoard/BoomAnimation/SpriteAnimation/Boom9.png';

import boomAnimationSheet from './Assets/Images/GameBoard/BoomAnimation/BoomAnimationSheet.png'


const terriotryHolderImage = {
  1: require('./Assets/Images/GameBoard/WorldMap/TerritoryHolder/PlayerBlue.png'),
  2: require('./Assets/Images/GameBoard/WorldMap/TerritoryHolder/PlayerGreen.png'),
  3: require('./Assets/Images/GameBoard/WorldMap/TerritoryHolder/PlayerRed.png'),
  4: require('./Assets/Images/GameBoard/WorldMap/TerritoryHolder/PlayerPink.png'),
  5: require('./Assets/Images/GameBoard/WorldMap/TerritoryHolder/PlayerYellow.png'),
  6: require('./Assets/Images/GameBoard/WorldMap/TerritoryHolder/PlayerPurple.png'),
};

/*const boomAnimationSprites = {
  1: require('./Assets/Images/GameBoard/BoomAnimation/SpriteAnimation/Boom1.png'),
  2: require('./Assets/Images/GameBoard/BoomAnimation/SpriteAnimation/Boom2.png'),
  3: require('./Assets/Images/GameBoard/BoomAnimation/SpriteAnimation/Boom3.png'),
  4: require('./Assets/Images/GameBoard/BoomAnimation/SpriteAnimation/Boom4.png'),
  5: require('./Assets/Images/GameBoard/BoomAnimation/SpriteAnimation/Boom5.png'),
  6: require('./Assets/Images/GameBoard/BoomAnimation/SpriteAnimation/Boom6.png'),
  7: require('./Assets/Images/GameBoard/BoomAnimation/SpriteAnimation/Boom7.png'),
  8: require('./Assets/Images/GameBoard/BoomAnimation/SpriteAnimation/Boom8.png'),
  9: require('./Assets/Images/GameBoard/BoomAnimation/SpriteAnimation/Boom9.png'),
} */

const boomAnimationSprites = [
  Boom1,
  Boom2,
  Boom3,
  Boom4,
  Boom5,
  Boom6,
  Boom7,
  Boom8,
  Boom9,
];

const TerritoryButton = ({territoryId, territoryRuler, territoryName, imageIndex, gamePhase, isSelectedTerritory, isTagetTerritory, style, topPos, overlayStyle, targetIconStyle, territoryWidth, territoryHeight, styleTerritoryHolderX, styleTerritoryHolderY, styleTerritoryHolderHeight, styleTerritoryHolderWidth, troopCount, addedTroopsCount, onAttackClick }) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const [counterAnimating, setCounterAnimating] = useState(false);

  //console.log(`Terrritory Name ====> ${territoryName} || Territory Ruler ====> ${territoryRuler}` );

  // Target Indicator Icon Values
  const [targetImageVisible, setTargetImageVisible] = useState(true);
  const [targetImagePosition, setTargetImagePosition] = useState({ x: 0, y: 0 });

  //Occupation Animation
  const [aniamtionImageUrl, setaniamtionImageUrl] = useState('');
  const [isImageAnimating, setIsImageAnimating] = useState(false);

  //Troops Added Animation
  const [troopsAddedImageUrl, setTroopsAddedImageUrl] = useState('');
  const [isTroopAddedAnimating, setIsTroopAddedAnimating] = useState(false);

  //Target Animation
  const [isTargetImageAnimating, setIsTargetImageAnimating] = useState(true);

/*if(territoryName === 'Alaska'){
  //console.log(`Is Target Territory ====> ${isTagetTerritory}`);
  console.log(`Top Pos ${topPos}`);
 // return;
} */

const totalFrames = 9; // Assuming there are 9 frames in the sprite sheet
const totalSpriteSheetWidth = 2063; // Total width of the sprite sheet image in pixels

const frameWidth = totalSpriteSheetWidth / totalFrames;

// Boom Animation
const [boomFrameIndex, setBoomFrameIndex] = useState(0);

/*useEffect(() => {
  // Start the animation loop for the boom animation
  const boomAnimationInterval = setInterval(() => {
    setBoomFrameIndex((prevIndex) => (prevIndex + 1) % 9); // Assuming 9 frames in the boom animation sprite sheet
  }, 500); // Adjust the interval duration for smoother or faster animation

  // Cleanup function to clear the interval
  return () => clearInterval(boomAnimationInterval);
}, []); */


const [boomImage, setBoomImage] = useState(boomAnimationSprites[0]);
const [isBoomAniamtion, setIsBoomAnimation] = useState(false);


//#region  Boom Animation

const boomAnimation = () => {

  let spriteIndex = 0;

  // Function to switch to the next sprite
  function nextSprite() {
      if (spriteIndex < boomAnimationSprites.length) {
          const boomImageLocal = boomAnimationSprites[spriteIndex];
          setBoomImage(boomImageLocal);
          spriteIndex++;
      } else {
       // Reset Animation State
      }
  }

  // Start the animation loop
  const animationInterval = setInterval(nextSprite, 100); // Adjust the interval for smoother or faster animation

  // Optionally, stop the animation after a certain duration
  setTimeout(() => {
      clearInterval(animationInterval);
      
     // setTimeout(() => {

       // Reset Animation
       setIsBoomAnimation(false);
        
    //  }, 2000);

  }, 1500); 


}

//#endregion

  useEffect(() => {
    console.log(' Territory Target  || Effect ');
    if (isTagetTerritory) {
      // Delay the animation for 1 second
      const animationTimeout = setTimeout(() => {
        // Set isTargetImageAnimating to false after the delay to start the animation
        setIsTargetImageAnimating(false);
      }, 1000);

      // Cleanup function to clear the timeout
      return () => clearTimeout(animationTimeout);
    }else{
      setIsTargetImageAnimating(true);
    }
  }, [isTagetTerritory]);


  const startImageAnimation = (imageUrl, timerValue) => {
    setaniamtionImageUrl(imageUrl);
    setIsImageAnimating(true);
    setTimeout(() => {
        setIsImageAnimating(false);
    }, 1000 * timerValue);
  };

  useEffect(() =>{
   if(gamePhase === 'Attack' && territoryRuler != ''){
      startImageAnimation(territoryOccupiedAnimation, 3);
      setIsBoomAnimation(true);
      boomAnimation();
    }
      
  }, [territoryRuler])

  const startTroopAddedAnimation = (imageUrl, timerValue) => {
    setTroopsAddedImageUrl(imageUrl);
    setIsTroopAddedAnimating(true);
    setTimeout(() => {
      setIsTroopAddedAnimating(false);
    }, 1000 * timerValue);
  };

  useEffect(() =>{
    startTroopAddedAnimation(troopAddedAnimation, 1);
  }, [troopCount])



  useEffect(() => {
    setIsAnimating(true);
    const timeout = setTimeout(() => {
      setIsAnimating(false);
    }, 100); // Adjust the animation duration as needed
    return () => clearTimeout(timeout);
  }, [troopCount]);

  useEffect(() => {
    setCounterAnimating(true);
    const timeout = setTimeout(() => {
      setCounterAnimating(false);
    }, 1000); // Adjust the animation duration as needed
    return () => clearTimeout(timeout);
  }, [troopCount]); // Trigger animation when troopCount changes

  window.onload = function() {
    document.body.onselectstart = function() {
        return false;
    }
  }

  //#region  Zoom Position Adjustment


/* let currentPosition = topPos;
   // Current position in percentage
  // const [currentPosition, setCurrentPosition] = useState(80);
   //const [adjustedPosition, setAdjustedPosition] = useState(0);

    // Calculate the reduction value based on the zoom level
    const reductionValue = () => {
      const zoomLevel = window.devicePixelRatio;
      let percentageToReduce = 0 ;// window.devicePixelRatio === 4 ? 5 : window.devicePixelRatio === 5 ? 6 : window.devicePixelRatio === 6 ?  6 : window.devicePixelRatio === 8 ? 8 : window.devicePixelRatio === 10 ? 10 : 1; // Default percentage to reduce
      console.log(`Zoom Level ====> ${zoomLevel}`);


      if (zoomLevel >= 4) {
        // Adjust reduction percentage based on zoom level
       // percentageToReduce = (zoomLevel - 1) * 100;
       // zoomLevel ==
       percentageToReduce = window.devicePixelRatio === 4 ? 5 : window.devicePixelRatio === 5 ? 7 : window.devicePixelRatio === 6 ?  9 : window.devicePixelRatio === 8 ? 11 : window.devicePixelRatio === 10 ? 13 : 1; // Default percentage to reduce
       console.log(`Percentage to Reduce =====> ${percentageToReduce}`);

      }
      console.log(`Current Position ====>  ${currentPosition } || Percentage Value ====> ${percentageToReduce} || Recution Value ===> ${((currentPosition * percentageToReduce) / 100)}`);
      return (currentPosition * percentageToReduce) / 100;
    };

    


  useEffect(() => {
    const handleZoomChange = () => {
      const newZoomLevel = window.devicePixelRatio;
  
     // const newZoomLevel = (window.outerWidth / window.innerWidth) * 100;
      //setZoomLevel(newZoomLevel);

     // console.log(`Zoom Level ====> ${newZoomLevel}`);
     if(territoryName === 'Alaska'){
      const reductionAmount = reductionValue();
      console.log(`Current Position Value ====> ${currentPosition} || Reduction Value ====> ${reductionAmount} || Updated Current Position Value ====>  ${currentPosition - reductionAmount}`);
      currentPosition = currentPosition - reductionAmount;//reductionValue();
      console.log(`Updated Current Position ====> ${currentPosition}`);
     }
      // Calculate the adjusted position
     // const newAdjustedPosition = topPos - reductionValue();
     // setAdjustedPosition(newAdjustedPosition);
     // console.log(`Adjusted Position ====> ${newAdjustedPosition}`);
      
    };

    handleZoomChange();
    window.addEventListener('resize', handleZoomChange);

    return () => {
      window.removeEventListener('resize', handleZoomChange);
    };

  }, []);


  // Output the values in the console
 /* useEffect(() => {
    /*console.log(`Current Position: ${currentPosition}%`);
    console.log(`Zoom Level: ${window.devicePixelRatio}`);
    console.log(`Reduction Value: ${reductionValue()}%`);
    console.log(`Adjusted Position: ${adjustedPosition}%`);
  }, [currentPosition, adjustedPosition]); */

  //#endregion

  //console.log(`Territory Name ====> ${territoryName}`);

  if(imageIndex === null || imageIndex === undefined){
    console.log(`Image Idex Value is In appropiate for ====> ${imageIndex} || of territory ====> ${territoryName}`);
    return;
  }

/*  if(territoryName !== 'Alaska'){
    //console.log(`Is Target Territory ====> ${isTagetTerritory}`);
    return;
  }

  if(territoryName === 'Alaska'){
    console.log(`Current Position ====> ${currentPosition}`);
    
  } 

  console.log(`Top Pos ${topPos}`); */
 // const currentPosition = topPos; //setCurrentPosition(topPos);

  const territoryImages = territoryImageData[territoryName];
  const imageSrcPath = territoryImages[imageIndex];
  const imageTerritoryHolderPath = terriotryHolderImage[imageIndex];

  // Apply animation class based on state
  const territoryHolderClassName = isAnimating ? 'territory-holder scale-up' : 'territory-holder';
  const counterClassName = counterAnimating ? 'counter scale-up' : 'counter';

  return (
    <div className={`territory-${territoryId}`} style={{...style, width: '100%', height: 'auto' }}>
      {/* <div className={`territory-${territoryId} ${isAnimating ? 'animating' : ''}`} style={{ position: 'relative', ...style, width: '100%', height: 'auto' }}> */}
      {/* Render background image */}
      <img className={`territory-background ${isSelectedTerritory ? 'dark-background' : ''}`} src={imageSrcPath} alt="Background Image" style={{
        width: '100%',
        maxWidth: territoryWidth,
        height: territoryHeight,
      //filter: 'brightness(0.5)', // Add the filter property
      /* Other styles */
      }} unselectable="on"/>

      {/* Render territory holder image and counter */}
      {imageTerritoryHolderPath && (
        <div className="image-container" style={{ position: 'absolute', top: styleTerritoryHolderY, left: styleTerritoryHolderX, width: styleTerritoryHolderWidth, height: styleTerritoryHolderHeight, zIndex: 5 }}>
          <img className={territoryHolderClassName} src={imageTerritoryHolderPath} alt="Territory Holder Image" style={{ position: 'absolute', width: '60%', height: '50%', objectFit: 'cover', zIndex: 8 }} /> 
          <div className={counterClassName} style={{ position: 'absolute', top: '25%', left: '30%', transform: 'translate(-50%, -50%)', color: 'white', fontSize: '0.8vw', fontFamily: 'Gomarice', zIndex: 10 }}>
            {troopCount}
          </div> 
        </div>
      )}

       {/* Image Animation */}
       {/*&& gamePhase === 'Attack' */}
     {/* Render boom animation */}
     {isBoomAniamtion && gamePhase === 'Attack'  &&(
      <img
      src={boomImage}
      alt="Animation Image"
      style={{
        position: 'absolute',
        left: `calc(${styleTerritoryHolderX} - 3%)`, // Center horizontally
        top: `calc(${styleTerritoryHolderY} - 50%)`, // Center vertically
        width: '10%', // Set width to auto to maintain aspect ratio
        height: 'auto', // Set height to auto to maintain aspect ratio
        transformOrigin: 'center center',
       // transform: `scale(${isImageAnimating ? 1 : 0})`, // Initial scale
       // transition: 'transform 1s', // Transition animation
        zIndex: 20,
      }}
      />
    )}

     {/* Troops Add Box Animation */}
    {imageTerritoryHolderPath && (
      <div
        style={{
          position: 'absolute',
          left: `calc(${styleTerritoryHolderX})`,
          top: `calc(${styleTerritoryHolderY} - 30%)`,
          zIndex: 20,
          transformOrigin: 'center center',
          transform: `scale(${isTroopAddedAnimating ? 1 : 0})`, // Initial scale
          transition: 'transform 1s', // Transition animation
        }}
        >
        {/* Animation Image */}
        <img
          src={troopsAddedImageUrl}
          alt="Animation Image"
          style={{
            width: '90%', // Set width to auto to maintain aspect ratio
            height: 'auto', // Set height to auto to maintain aspect ratio
          }}
        />

        {/* Animation Text */}
        <div style={{ position: 'absolute', top: '40%', left: '45%', transform: 'translate(-50%, -50%)', fontWeight: 'bold', color: 'black', fontSize: '1vw', fontFamily: 'Gomarice', zIndex: 21 }}>
          {addedTroopsCount}
        </div>
      </div>
    )}

     
    <img
      src={targetIndicator}
      alt="Target Image"
      style={{
        ...targetIconStyle,
        width: '10%', // Set width to auto to maintain aspect ratio
        height: 'auto', // Set height to auto to maintain aspect ratio
        transformOrigin: 'center center',
        transform: `scale(${isTargetImageAnimating ? 2 : 0})`, // Scale factor managed dynamically
        transition: 'transform 1s', // Transition animation
        zIndex: 20,
        visibility: isTagetTerritory ? 'visible' : 'hidden', // Show/hide the target indicator
      }}
    />



      {/* Invisible overlay to capture click events */}
      {/*backgroundColor: 'rgba(255, 0, 0, 0.5)' 8*/}
      <div className="overlay"  onClick={onAttackClick} style={{ ...overlayStyle, zIndex: 5 }}></div>

    </div>

    
  );
};

export default TerritoryButton;